import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import Card from './Card';
import { type MonthGroup } from '../utils/calendarUtils';

interface CalendarViewProps {
  monthGroups: MonthGroup[];
  showMonthHeaders?: boolean;
  onGenerate?: (cardId: string) => void;
  onDelete?: (cardId: string) => void;
  onCancel?: (cardId: string) => void;
  isOwnPage?: boolean;
}

const CalendarView: React.FC<CalendarViewProps> = ({
  monthGroups,
  showMonthHeaders = true,
  onGenerate,
  onDelete,
  onCancel,
  isOwnPage = false
}) => {
  const { theme } = useTheme();


  return (
    <div className="space-y-12">
      {monthGroups.map((monthGroup) => (
        <div key={monthGroup.value}>
          {/* 月セクションヘッダー */}
          {showMonthHeaders && (
            <div className="mb-6">
              <h2 className={`text-2xl fira-sans-extra-bold-italic mb-1 ${
                theme === 'dark' ? 'text-zinc-500' : ''
              }`} style={theme === 'light' ? { color: '#B3A5A9' } : {}}>
                {monthGroup.name} {monthGroup.value.split('-')[0]}
              </h2>
              <div className="h-px bg-theme-secondary/50"></div>
            </div>
          )}

          {/* 日別カード表示 */}
          <div className="space-y-6">
            {monthGroup.cards.map((dayData) => (
              <div key={dayData.date.toISOString()} className="sm:mx-0 -mx-4">
                <div className="flex sm:grid sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-5 xl:grid-cols-6 gap-3 overflow-x-auto sm:overflow-x-visible scrollbar-hide px-4 sm:px-0">
                  {/* Date Block */}
                  <div className={`flex-shrink-0 w-28 sm:w-auto sm:flex-shrink aspect-[3/4] rounded-lg ${theme === 'dark' ? 'bg-zinc-700' : 'bg-theme-secondary'} relative`}>
                    <div className="absolute top-4 left-4">
                      <div className={`text-5xl fira-sans-extra-bold-italic leading-none ${
                        theme === 'dark' ? 'text-zinc-500' : ''
                      }`} style={theme === 'light' ? { color: '#B3A5A9' } : {}}>
                        {dayData.dayNumber}
                      </div>
                      <div className={`text-sm fira-sans-book-italic ${
                        theme === 'dark' ? 'text-zinc-500' : ''
                      }`} style={theme === 'light' ? { color: '#B3A5A9' } : {}}>
                        {dayData.dayName}
                      </div>
                    </div>
                  </div>

                  {/* カード表示 */}
                  {dayData.cards.map((card) => {
                    return (
                      <div
                        key={card.id}
                        className="flex-shrink-0 w-40 sm:w-auto sm:flex-shrink"
                      >
                        <Card
                          card={card}
                          onGenerate={isOwnPage && onGenerate ? () => onGenerate(card.id) : () => {}}
                          onDelete={isOwnPage && onDelete ? () => onDelete(card.id) : () => {}}
                          onCancel={isOwnPage && onCancel ? () => onCancel(card.id) : undefined}
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}

    </div>
  );
};

export default CalendarView;
